// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checklist-form__background {
  background: #f5f5f5;
}
.checklist-form__card-profile-changes {
  margin: auto;
  background-color: #ffffff;
  border: 1px solid #f3f5f6;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
}
.checklist-form__head {
  background: #f5f5f5;
  margin-bottom: 30px;
}
.checklist-form__head__head-text {
  padding-top: 10px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
}
.checklist-form__head__subhead-text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #868686;
  padding-top: 10px;
}
.checklist-form__body {
  padding-top: 30px;
}
.checklist-form__body__table {
  width: 100%;
}
.checklist-form__body__left {
  width: 65%;
  border-right: 1px solid #e9e9e9;
}
.checklist-form__body__right {
  width: 35%;
  padding: 3%;
}

.checklist-form-cards {
  width: 100%;
  background: #f5f5f5;
  padding-bottom: 25px;
}

.checklist-form-basic-info {
  padding: 5%;
}
.checklist-form-basic-info__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #353d47;
}
.checklist-form-basic-info__body {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
  margin-top: 30px;
}
.checklist-form-basic-info__form {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #353d47;
}
.checklist-form-basic-info__date {
  display: flex;
  width: 100%;
  margin-top: 30px;
}
.checklist-form-basic-info__date__calendar-input {
  margin-right: 20px;
  width: 400px;
}
.checklist-form-basic-info__date__dual-input {
  margin-top: 20px;
  width: 100%;
}
.checklist-form-basic-info__date__col1 {
  float: left;
  width: 50%;
  padding-right: 10px;
}
.checklist-form-basic-info__date__col2 {
  float: left;
  width: 50%;
  margin-top: 20px;
}
.checklist-form-basic-info__selections {
  margin-top: 30px;
}
.checklist-form-basic-info__recurring-cycle {
  display: flex;
}
.checklist-form-basic-info__recurring-cycle__col1 {
  float: left;
  width: 24%;
  margin-right: 10px;
}
.checklist-form-basic-info__recurring-cycle__col2 {
  float: left;
  width: 24%;
  margin-right: 10px;
}
.checklist-form-basic-info__recurring-cycle__col3 {
  margin-top: auto;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  width: 50%;
  column-gap: 1px;
}
.checklist-form-basic-info__squares-left {
  justify-content: center;
  align-items: center;
  padding-top: 8px;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  height: 42px;
  width: 42px;
  margin-right: 5px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
}
.checklist-form-basic-info__squares-center {
  justify-content: center;
  align-items: center;
  padding-top: 10px;
  text-align: center;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  height: 42px;
  width: 42px;
  margin-right: 5px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
}
.checklist-form-basic-info__squares-right {
  justify-content: center;
  align-items: center;
  padding-top: 8px;
  text-align: center;
  border: 1px solid #e9e9e9;
  border-radius: 8px;
  height: 42px;
  width: 42px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
}
.checklist-form-basic-info .squares-selected {
  background: #4a515e;
  color: #ffffff;
}
.checklist-form-basic-info .squares-not-selected {
  background: #ffffff;
  color: #505054;
}

.checklist-form-right__part1 {
  margin-top: 50px;
}
.checklist-form-right__part2 {
  margin-top: 100px;
}
.checklist-form-right__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #666666;
}
.checklist-form-right__body {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}

.staff-in-charge {
  padding: 5%;
}
.staff-in-charge__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #353d47;
}

.select-staff-dual-input {
  margin-top: 30px;
}
.select-staff-dual-input__inputs {
  display: flex;
}
.select-staff-dual-input__inputs__dropdown {
  width: 100%;
}
.select-staff-dual-input__dropdown-select {
  width: 100%;
  height: 56px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px 0px 0px 8px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
}
.select-staff-dual-input__dropdown__select {
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px 0px 0px 8px;
  height: 60px;
  width: 100%;
  padding-left: 10px;
}
.select-staff-dual-input__checkbox__div {
  border: 1px solid #e9e9e9;
  width: 174px;
  height: 56px;
  border-radius: 0px 8px 8px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.select-staff-dual-input__text-label {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.select-staff-dual-input__info {
  margin-left: auto;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
  display: flex;
}
.select-staff-dual-input__info__icon {
  padding-right: 5px;
}
.select-staff-dual-input__time-input {
  margin-top: 30px;
}
.select-staff-dual-input__check-point {
  display: flex;
}
.select-staff-dual-input__check-point__label {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}

.checklist-setting {
  padding: 5%;
}
.checklist-setting__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #353d47;
}
.checklist-setting__body {
  margin-top: 30px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}
.checklist-setting__table {
  width: 100%;
}
.checklist-setting__table__tr {
  height: 50px;
}

.checklist-items {
  padding: 5%;
}
.checklist-items__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
  color: #353d47;
}
.checklist-items__body {
  margin-top: 30px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}
.checklist-items__table {
  width: 100%;
}
.checklist-items__table__tr {
  height: 50px;
}
.checklist-items__textbox {
  width: 100%;
  height: 56px;
  border: none;
  border-bottom: 1px solid #e9e9e9;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}
.checklist-items__textbox:focus {
  border-bottom: 1px solid #075453;
  outline: none;
}
.checklist-items__textbox-disabled {
  width: 100%;
  height: 56px;
  border: none;
  border-bottom: 1px solid #e9e9e9;
  color: #999999;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}
.checklist-items__textbox-top {
  margin-top: 20px;
}
.checklist-items__add-check-item {
  margin-top: 30px;
}
.checklist-items__add-check-item__text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #075453;
  width: 150px;
  cursor: pointer;
}

.checklist-items-icon {
  position: relative;
  z-index: 0;
}
.checklist-items-icon__icon {
  position: absolute;
  right: 10px;
  top: 15px;
  cursor: pointer;
}

@media (max-width: 1400px) {
  .checklist-form-basic-info__squares-center {
    height: 38px;
    width: 38px;
    padding-top: 20px;
  }
}
@media (max-width: 1300px) {
  .checklist-form-basic-info__squares-center {
    height: 34px;
    width: 34px;
  }
}
.css-12a83d4-MultiValueRemove:hover {
  background: transparent !important;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/screens/checklist/checklist-form/checklist-form.scss"],"names":[],"mappings":"AAEI;EACI,mBAAA;AADR;AAII;EACI,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,4CAAA;EACA,kBAAA;AAFR;AAKI;EACI,mBAAA;EACA,mBAAA;AAHR;AAKQ;EACI,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAHZ;AAMQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAJZ;AAQI;EACI,iBAAA;AANR;AAQQ;EACI,WAAA;AANZ;AASQ;EACI,UAAA;EACA,+BAAA;AAPZ;AAUQ;EACI,UAAA;EACA,WAAA;AARZ;;AAaA;EACI,WAAA;EACA,mBAAA;EACA,oBAAA;AAVJ;;AAaA;EACI,WAAA;AAVJ;AAYI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAVR;AAaI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAXR;AAcI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAZR;AAeI;EACI,aAAA;EACA,WAAA;EACA,gBAAA;AAbR;AAeQ;EACI,kBAAA;EACA,YAAA;AAbZ;AAgBQ;EACI,gBAAA;EACA,WAAA;AAdZ;AAiBQ;EACI,WAAA;EACA,UAAA;EACA,mBAAA;AAfZ;AAkBQ;EACI,WAAA;EACA,UAAA;EACA,gBAAA;AAhBZ;AAoBI;EACI,gBAAA;AAlBR;AAqBI;EACI,aAAA;AAnBR;AAqBQ;EACI,WAAA;EACA,UAAA;EACA,kBAAA;AAnBZ;AAsBQ;EACI,WAAA;EACA,UAAA;EACA,kBAAA;AApBZ;AAuBQ;EACI,gBAAA;EACA,aAAA;EACA,qCAAA;EACA,UAAA;EACA,eAAA;AArBZ;AAyBI;EACI,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAvBR;AA0BI;EACI,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAzBR;AA4BI;EACI,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AA1BR;AA6BI;EACI,mBAAA;EACA,cAAA;AA3BR;AA8BI;EACI,mBAAA;EACA,cAAA;AA5BR;;AAiCI;EACI,gBAAA;AA9BR;AAiCI;EACI,iBAAA;AA/BR;AAkCI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAhCR;AAmCI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAjCR;;AAqCA;EACI,WAAA;AAlCJ;AAoCI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAlCR;;AAsCA;EACI,gBAAA;AAnCJ;AAoCI;EACI,aAAA;AAlCR;AAoCQ;EACI,WAAA;AAlCZ;AAsCI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AArCR;AAyCQ;EACI,mBAAA;EACA,yBAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AAvCZ;AA4CQ;EACI,yBAAA;EACA,YAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EAEA,uBAAA;EACA,mBAAA;AA3CZ;AA+CI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA7CR;AAgDI;EACI,iBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;AA9CR;AAgDQ;EACI,kBAAA;AA9CZ;AAkDI;EACI,gBAAA;AAhDR;AAmDI;EACI,aAAA;AAjDR;AAmDQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAjDZ;;AAsDA;EACI,WAAA;AAnDJ;AAqDI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAnDR;AAsDI;EACI,gBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AArDR;AAwDI;EACI,WAAA;AAtDR;AAwDQ;EACI,YAAA;AAtDZ;;AA2DA;EACI,WAAA;AAxDJ;AA0DI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAxDR;AA2DI;EACI,gBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA1DR;AA6DI;EACI,WAAA;AA3DR;AA6DQ;EACI,YAAA;AA3DZ;AA+DI;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,gCAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA9DR;AAiEI;EACI,gCAAA;EACA,aAAA;AA/DR;AAkEI;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,gCAAA;EACA,cAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAjER;AAoEI;EACI,gBAAA;AAlER;AAqEI;EACI,gBAAA;AAnER;AAqEQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;AAnEZ;;AAwEA;EACI,kBAAA;EACA,UAAA;AArEJ;AAuEI;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;AArER;;AAyEA;EACI;IACI,YAAA;IACA,WAAA;IACA,iBAAA;EAtEN;AACF;AAyEA;EACI;IACI,YAAA;IACA,WAAA;EAvEN;AACF;AA0EA;EACI,kCAAA;EACA,eAAA;AAxEJ","sourcesContent":[".checklist-form {\n\n    &__background {\n        background: #f5f5f5;\n    }\n\n    &__card-profile-changes {\n        margin: auto;\n        background-color: #ffffff;\n        border: 1px solid #f3f5f6;\n        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n        border-radius: 8px;\n    }\n\n    &__head {\n        background: #f5f5f5;\n        margin-bottom: 30px;\n\n        &__head-text {\n            padding-top: 10px;\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 28px;\n        }\n\n        &__subhead-text {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 14px;\n            line-height: 20px;\n            color: #868686;\n            padding-top: 10px;\n        }\n    }\n\n    &__body {\n        padding-top: 30px;\n\n        &__table {\n            width: 100%;\n        }\n\n        &__left {\n            width: 65%;\n            border-right: 1px solid #e9e9e9;\n        }\n\n        &__right {\n            width: 35%;\n            padding: 3%;\n        }\n    }\n}\n\n.checklist-form-cards {\n    width: 100%;\n    background: #f5f5f5;\n    padding-bottom: 25px;\n}\n\n.checklist-form-basic-info {\n    padding: 5%;\n\n    &__head {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 20px;\n        line-height: 30px;\n        color: #353d47;\n    }\n\n    &__body {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        color: #505054;\n        margin-top: 30px;\n    }\n\n    &__form {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 20px;\n        line-height: 30px;\n        color: #353d47;\n    }\n\n    &__date {\n        display: flex;\n        width: 100%;\n        margin-top: 30px;\n\n        &__calendar-input {\n            margin-right: 20px;\n            width: 400px;\n        }\n\n        &__dual-input {\n            margin-top: 20px;\n            width: 100%;\n        }\n\n        &__col1 {\n            float: left;\n            width: 50%;\n            padding-right: 10px;\n        }\n\n        &__col2 {\n            float: left;\n            width: 50%;\n            margin-top: 20px;\n        }\n    }\n\n    &__selections {\n        margin-top: 30px;\n    }\n\n    &__recurring-cycle {\n        display: flex;\n\n        &__col1 {\n            float: left;\n            width: 24%;\n            margin-right: 10px;\n        }\n\n        &__col2 {\n            float: left;\n            width: 24%;\n            margin-right: 10px;\n        }\n\n        &__col3 {\n            margin-top: auto;\n            display: grid;\n            grid-template-columns: repeat(7, 1fr);\n            width: 50%;\n            column-gap: 1px;\n        }\n    }\n\n    &__squares-left {\n        justify-content: center;\n        align-items: center;\n        padding-top: 8px;\n        border: 1px solid #e9e9e9;\n        border-radius: 8px;\n        height: 42px;\n        width: 42px;\n        margin-right: 5px;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        text-align: center;\n    }\n\n    &__squares-center {\n        justify-content: center;\n        align-items: center;\n        padding-top: 10px;\n        text-align: center;\n        border: 1px solid #e9e9e9;\n        border-radius: 8px;\n        height: 42px;\n        width: 42px;\n        margin-right: 5px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        text-align: center;\n        cursor: pointer;\n    }\n\n    &__squares-right {\n        justify-content: center;\n        align-items: center;\n        padding-top: 8px;\n        text-align: center;\n        border: 1px solid #e9e9e9;\n        border-radius: 8px;\n        height: 42px;\n        width: 42px;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        text-align: center;\n    }\n\n    .squares-selected {\n        background: #4a515e;\n        color: #ffffff;\n    }\n\n    .squares-not-selected {\n        background: #ffffff;\n        color: #505054;\n    }\n}\n\n.checklist-form-right {\n    &__part1 {\n        margin-top: 50px;\n    }\n\n    &__part2 {\n        margin-top: 100px;\n    }\n\n    &__head {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        color: #666666;\n    }\n\n    &__body {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18px;\n        color: #999999;\n    }\n}\n\n.staff-in-charge {\n    padding: 5%;\n\n    &__head {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 20px;\n        line-height: 30px;\n        color: #353d47;\n    }\n}\n\n.select-staff-dual-input {\n    margin-top: 30px;\n    &__inputs {\n        display: flex;\n\n        &__dropdown {\n            width: 100%;\n        }\n    }\n\n    &__dropdown-select {\n        width: 100%;\n        height: 56px;\n        background: #ffffff;\n        border: 1px solid #e9e9e9;\n        border-radius: 8px 0px 0px 8px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n    }\n\n    &__dropdown {\n        &__select {\n            background: #ffffff;\n            border: 1px solid #e9e9e9;\n            border-radius: 8px 0px 0px 8px;\n            height: 60px;\n            width: 100%;\n            padding-left: 10px;\n        }\n    }\n\n    &__checkbox {\n        &__div {\n            border: 1px solid #e9e9e9;\n            width: 174px;\n            height: 56px;\n            border-radius: 0px 8px 8px 0px;\n            display: flex;\n\n            justify-content: center;\n            align-items: center;\n        }\n    }\n\n    &__text-label {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        color: #505054;\n    }\n\n    &__info {\n        margin-left: auto;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 12px;\n        line-height: 18px;\n        color: #999999;\n        display: flex;\n\n        &__icon {\n            padding-right: 5px;\n        }\n    }\n\n    &__time-input {\n        margin-top: 30px;\n    }\n\n    &__check-point {\n        display: flex;\n\n        &__label {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            line-height: 20px;\n            color: #505054;\n        }\n    }\n}\n\n.checklist-setting {\n    padding: 5%;\n\n    &__head {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 20px;\n        line-height: 30px;\n        color: #353d47;\n    }\n\n    &__body {\n        margin-top: 30px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n        color: #333333;\n    }\n\n    &__table {\n        width: 100%;\n\n        &__tr {\n            height: 50px;\n        }\n    }\n}\n\n.checklist-items {\n    padding: 5%;\n\n    &__head {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 20px;\n        line-height: 30px;\n        color: #353d47;\n    }\n\n    &__body {\n        margin-top: 30px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n        color: #333333;\n    }\n\n    &__table {\n        width: 100%;\n\n        &__tr {\n            height: 50px;\n        }\n    }\n\n    &__textbox {\n        width: 100%;\n        height: 56px;\n        border: none;\n        border-bottom: 1px solid #e9e9e9;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n    }\n\n    &__textbox:focus {\n        border-bottom: 1px solid #075453;\n        outline: none;\n    }\n\n    &__textbox-disabled {\n        width: 100%;\n        height: 56px;\n        border: none;\n        border-bottom: 1px solid #e9e9e9;\n        color: #999999;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n    }\n\n    &__textbox-top {\n        margin-top: 20px;\n    }\n\n    &__add-check-item {\n        margin-top: 30px;\n\n        &__text {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 500;\n            font-size: 16px;\n            line-height: 22px;\n            color: #075453;\n            width: 150px;\n            cursor: pointer;\n        }\n    }\n}\n\n.checklist-items-icon {\n    position: relative;\n    z-index: 0;\n\n    &__icon {\n        position: absolute;\n        right: 10px;\n        top: 15px;\n        cursor: pointer;\n    }\n}\n\n@media (max-width: 1400px) {\n    .checklist-form-basic-info__squares-center {\n        height: 38px;\n        width: 38px;\n        padding-top: 20px;\n    }\n}\n\n@media (max-width: 1300px) {\n    .checklist-form-basic-info__squares-center {\n        height: 34px;\n        width: 34px;\n    }\n}\n\n.css-12a83d4-MultiValueRemove:hover {\n    background: transparent !important;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
